const CompanyHeader = () => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <div className="d-sm-flex align-items-center justify-content-between">
            <div className="fs-16 fw-bold">Set Up My Company</div>
          </div>
          <div className="page-title-left">
            <ol className="breadcrumb m-0">
              {/* <li className="breadcrumb-item">
                <a href="/r/client-dashboard">
                  <span className="fw-bold">Clients</span>
                </a>
              </li> */}
              <li className="breadcrumb-item text-muted">Create Company</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CompanyHeader;
